import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "../components/Logo";

export default function Privacy() {
    return (
        <div className="min-h-screen bg-[#FAFAF8] text-[#1C1A18]">
            <header className="border-b border-[#e6e2db]">
                <div className="max-w-3xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
                    <Link
                        to="/"
                        className="flex items-center"
                        data-testid="privacy-back-logo"
                    >
                        <Logo size="sm" />
                    </Link>
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 text-[10px] tracking-[0.32em] uppercase text-[#1C1A18]/70 hover:text-[#1C1A18]"
                        data-testid="privacy-back-link"
                    >
                        <ArrowLeft size={14} /> Volver
                    </Link>
                </div>
            </header>

            <main className="max-w-3xl mx-auto px-6 lg:px-12 py-16">
                <span className="text-[10px] tracking-[0.4em] uppercase text-[#C4A882]">
                    Legal
                </span>
                <h1 className="font-display text-4xl sm:text-5xl text-[#1C1A18] mt-3 leading-[1.1]">
                    Política de privacidad y cookies
                </h1>

                <div className="mt-10 space-y-8 text-[#3b3833] font-light leading-relaxed text-[15px]">
                    <section>
                        <h2 className="font-display text-2xl text-[#1C1A18] mb-3">
                            Responsable
                        </h2>
                        <p>
                            Silvia García — fotógrafa profesional con estudio en
                            Sestao (Bizkaia, País Vasco). Para cualquier consulta
                            relacionada con tus datos personales, puedes
                            contactarnos a través de WhatsApp o del formulario de
                            la web.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-[#1C1A18] mb-3">
                            Datos que tratamos
                        </h2>
                        <p>
                            Solo recogemos los datos que tú decides facilitarnos
                            voluntariamente al usar el formulario de contacto o
                            iniciar una conversación por WhatsApp (nombre,
                            teléfono, email y mensaje). No vendemos ni cedemos
                            tus datos a terceros.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-[#1C1A18] mb-3">
                            Cookies
                        </h2>
                        <p>
                            Esta web utiliza cookies <strong>propias técnicas</strong>{" "}
                            estrictamente necesarias para el funcionamiento del
                            sitio (recordar tu consentimiento, mantener la sesión
                            del panel de administración). Estas cookies no
                            requieren tu autorización.
                        </p>
                        <p className="mt-3">
                            Con tu consentimiento, podemos usar cookies{" "}
                            <strong>opcionales</strong> para mejorar la
                            experiencia (analítica anónima). Si pulsas{" "}
                            <em>"Solo necesarias"</em>, estas cookies no se
                            activarán.
                        </p>
                        <p className="mt-3">
                            Puedes revocar tu consentimiento en cualquier momento
                            borrando los datos del navegador o pulsando el botón
                            que aparece a continuación:
                        </p>
                        <button
                            type="button"
                            onClick={() => {
                                try {
                                    localStorage.removeItem("sg_cookies_consent_v1");
                                } catch {
                                    /* ignore */
                                }
                                window.location.href = "/";
                            }}
                            data-testid="cookie-reset-btn"
                            className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 border border-[#1C1A18] text-[10px] uppercase tracking-[0.28em] hover:bg-[#1C1A18] hover:text-white transition-colors"
                        >
                            Cambiar mis preferencias de cookies
                        </button>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-[#1C1A18] mb-3">
                            Tus derechos
                        </h2>
                        <p>
                            En cumplimiento del RGPD y la LOPDGDD, tienes derecho
                            a acceder, rectificar, suprimir, oponerte y limitar
                            el tratamiento de tus datos. Para ejercerlos, envía
                            una solicitud por WhatsApp o a través del formulario
                            de contacto.
                        </p>
                    </section>

                    <p className="text-xs text-[#9a958c]">
                        Última actualización: febrero 2026
                    </p>
                </div>
            </main>
        </div>
    );
}
